import { setSurveyResponse } from '../redux/action/surveyAction';
import { savedSuccessFullySurvey } from '../redux/action/saveAction'
import { updateSurveyResponse, saveSurveyResponse, saveUserResponse, saveTpsAnswers, deleteOSContact  } from '../services/survey.service';
import { URL_SURVEY_API, REACT_APP_URL_SURVEY_API_EXT  } from '../utils/constEnvVariables'
import { DAYS_WEEKS,SCBM_SECCIO_CODES,TABLE_SECT, FLEXIBILITY_SECTION_NAME, FLEX_TABLE, OPEN, NON_OKTA_USER, TPS } from './surveyLiterals';
import { saveCooAnswers } from '../services/coo.service';


function createResponseApiObject(surveyAnswers, campaign, userInfo) {
    const dataAnswers = [];
    const apiResponse = getBaseResponseObject(campaign, userInfo);

    const apiAnswer = getBaseAnswer(userInfo);

    surveyAnswers.map(answer => {
        dataAnswers.push({
            ...apiAnswer,
            answer: answer.answer,
            questionId: answer.questionId,
            tierIndex: answer.tierIndex === undefined ? 0 : answer.tierIndex
        })
        return dataAnswers
    })
    apiResponse.surveyAnswers = dataAnswers
    apiResponse.updatedBy = userInfo.userID
    return apiResponse;
}


function updateResponseApiObject(response, surveyAnswers, userInfo) {
    surveyAnswers.forEach(el => {
        el.createdBy = el.createdBy ? el.createdBy : userInfo.userID;
        el.tierIndex = el.tierIndex ? el.tierIndex : 0;
        el.active = true;
        el.surveyResponseId = el.surveyResponseId ? el.surveyResponseId : response.id;
    });
    response.surveyAnswers = [...surveyAnswers]
    response.updatedBy = userInfo.userID
    return response;
}


function handleSaveOrUpdate(surveyResponse, surveyAnswers, campaign, userInfo, authState, dispatch, message, survey) {
    deleteAnswers(surveyAnswers, survey)
    if (!Object.keys(surveyResponse).length) {
        const apiResponse = createResponseApiObject(surveyAnswers, campaign, userInfo)
        return saveSurveyResponse(apiResponse, authState.accessToken.accessToken)
            .then(res => {
                if (res.id) {
                    dispatch(setSurveyResponse(res))
                    dispatch(savedSuccessFullySurvey({
                        variant: 'success',
                        updatedResponse: res,
                        description: message
                    }))
                    return res
                }
            }).catch(error => {
                dispatch(savedSuccessFullySurvey({
                    variant: 'error',
                    description: error.toString()
                }))
                return null
            })
    }
    else {
        const apiResponse = updateResponseApiObject(surveyResponse, surveyAnswers, userInfo)
        apiResponse.campaignId = campaign.id;
        return updateSurveyResponse(campaign.surveyId, campaign.assignments[0].supplierNumber, apiResponse, authState.accessToken.accessToken)
            .then(res => {
                if (res.id) {
                    dispatch(setSurveyResponse(res))
                    dispatch(savedSuccessFullySurvey({
                        variant: 'success',
                        updatedResponse: res,
                        description: message
                    }))
                    return res
                }
            }).catch(error => {
                dispatch(savedSuccessFullySurvey({
                    variant: 'error',
                    description: error.toString()
                }))
                return null
            })
    }
}

function deleteAnswers(surveyAnswers, survey) {
    if (!surveyAnswers || !survey) {
        return;
    }
    surveyAnswers.forEach(currentAnswer => {
        survey.sections.forEach(section => {
            const currentDaysWeekQuestion = findDaysWeeks(section,currentAnswer.questionId);
            findCommentsTableFX(section,surveyAnswers);
            const currentQuestion = section.questions.find(q => q.id === currentAnswer.questionId);
            // special case for DAYS/WEEKS Question
          if (currentDaysWeekQuestion) {
                const childQuestion = section.questions.find(q => q.idQuestionDepends === currentDaysWeekQuestion.id);
                if(childQuestion){
                    const childAnswer = surveyAnswers.find(a => a.questionId === childQuestion.id)
                    if(childAnswer && Number.parseInt(currentAnswer.answer) < childQuestion.idSelectionDependson){
                        childAnswer.answer = '';
                    }
                }
            }
            else if (currentQuestion && currentQuestion.idQuestionDepends) {
                const parentQuestion = section.questions.find(q => q.id === currentQuestion.idQuestionDepends);
                const parentQuestionAnswer = parentQuestion ? surveyAnswers.find(an => an.questionId === parentQuestion.id) : null;
                if (parentQuestionAnswer && parentQuestion && parentQuestion.text !== DAYS_WEEKS) {
                    const splitedAnswers = parentQuestionAnswer.answer.split(',')
                    if (!splitedAnswers.includes(currentQuestion.idSelectionDependson.toString())) {
                        deleteChildrenAnswers(section, currentQuestion.id, surveyAnswers)
                        currentAnswer.answer = '';
                    }
                }
            }

        })
    })
}

function deleteChildrenAnswers(section, currentQuestionAnswerId, surveyAnswers) {
    const childrenQuestions = section.questions.filter(q => q.idQuestionDepends === currentQuestionAnswerId);
    childrenQuestions.forEach(question => {
        const childrenAnwers = surveyAnswers.filter(sa => question.id === sa.questionId);
        childrenAnwers.forEach(child => child.answer = '');
    })
}

function findDaysWeeks(section,currentAnswerQuestionId){
    let questionFound = null;
    if(section && currentAnswerQuestionId && section.code === SCBM_SECCIO_CODES.CC){
        const tableSectQuestions = section.questions.filter(q => q.type === TABLE_SECT);
        if(tableSectQuestions){
             tableSectQuestions.forEach(q=> {
                const found = q.dependentQuestions.find(q=>q.id === currentAnswerQuestionId)
                if(found){
                    questionFound = found
                }
            })
        }
    }
    return questionFound;
}

function findCommentsTableFX(section,surveyAnswers) {
    if(section && surveyAnswers && section.description === FLEXIBILITY_SECTION_NAME){
        const tableCommQuestions = section.questions.filter(q => q.type === FLEX_TABLE);
        if(tableCommQuestions){
            tableCommQuestions.forEach(q=> {
                const question = q.dependentQuestions.find( q => q.type === OPEN);
                let answQuesDependOn;
                if(question && question.idQuestionDepends) {
                    answQuesDependOn = surveyAnswers.find( a => a.questionId === question.idQuestionDepends );
                }
                if( answQuesDependOn && question && question.idSelectionDependson &&
                        Number.parseInt(answQuesDependOn.answer) !== Number.parseInt(question.idSelectionDependson) ) {
                    const answer = surveyAnswers.find( sa => sa.questionId === question.id );
                    if( answer ) answer.answer = '';
                }
            })
        }
    }
}

function saveUserAnswers(surveyResponse, surveyAnswers, campaign, userInfo, authState) {
    let responseObj;
    if (surveyResponse && surveyResponse.id) {
        responseObj = surveyResponse;
        responseObj.updatedBy = userInfo ? userInfo.userID : NON_OKTA_USER;
        responseObj.campaignId = campaign.id;
    } else {
        responseObj = getBaseResponseObject(campaign, userInfo);
    }
    let ansArray = surveyAnswers.map((item) => item.id);
    responseObj.surveyAnswers = responseObj.surveyAnswers.filter((ans)=>{return ansArray.includes(ans.id)});
    if (surveyAnswers) {
        for (let currentAnswer of surveyAnswers) {
            let tmpAnswer = responseObj.surveyAnswers.find(ans => ans.questionId === currentAnswer.questionId);
            if (!tmpAnswer) {
                tmpAnswer = getBaseAnswer(userInfo);
                responseObj.surveyAnswers.push(tmpAnswer);
            }
            tmpAnswer.questionId = currentAnswer.questionId;
            tmpAnswer.answer = currentAnswer.answer;
        }
    }

    let isAuthMethodOkta = authState && authState.isAuthenticated ? true : false;
    let token = isAuthMethodOkta ? authState.accessToken.accessToken : "";

    return saveUserResponse(responseObj, token, isAuthMethodOkta)
        .then(res => {
            if (res.id) {
                return {
                    variant: 'success',
                    updatedResponse: res
                }
            }
        }).catch(error => {
            return {
                variant: 'error',
                description: error.toString()
            }
        })
}

function getBaseResponseObject(campaign, userInfo) {
    return {
        active: true,
        surveyId: campaign.surveyId,
        createdBy: userInfo ? userInfo.userID : NON_OKTA_USER,
        updatedBy: userInfo ? userInfo.userID : NON_OKTA_USER,
        supplierNumber: campaign.assignments[0].supplierNumber,
        campaignId: campaign.id,
        surveyAnswers: []
    }
}

function getBaseAnswer(userInfo) {
    return {
        answer: undefined,
        active: true,
        questionId: undefined,
        createdBy: userInfo ? userInfo.userID : NON_OKTA_USER,
        tierIndex: 0
    }
}

function uploadSurveyFile(file, campaign, fileversion, userInfo, authState) {
    const campaignId = campaign.id
    const requestNumber = campaign.assignments[0].id
    return uploadFile(file, campaignId, requestNumber, fileversion, userInfo, authState.accessToken.accessToken)
        .then(res => {
            if (res.id) {
                return {
                    variant: 'success',
                    updatedResponse: res
                }
            }
        }).catch(error => {
            return {
                variant: 'error',
                description: error.toString()
            }
        })
}

const uploadFile = async function (form, campaignId, requestNumber, fileversion, userinfo, accessToken) {
    return await fetch(`${URL_SURVEY_API}/surveys/files/${campaignId}&${requestNumber}&${fileversion}`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Accept': 'application/json',
        },
        body: form
    });
}


const postCMSurvey = async function (accessToken, file, userId) {
    let fd = new FormData(); 
    fd.append('file', file[0]);
    fd.append('userId', userId);
    fd.append('content-type',file[0].type); 
    
    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Accept' : '*/*',
        },
        body: fd
    }

     return await fetch(`${URL_SURVEY_API}/surveys/campaign/cm`, requestOptions);
}

const postEMSurvey = async function (accessToken, file, userId) {
    let fd = new FormData(); 
    fd.append('file', file[0]);
    fd.append('userId', userId);
    fd.append('content-type',file[0].type); 
    
    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Accept' : '*/*',
        },
        body: fd
    }

     return await fetch(`${URL_SURVEY_API}/surveys/campaign/em`, requestOptions);
}

const postCMResponse = async function (accessToken, file, userId, assignmentId, campaignId, isAuthMethodOkta) {
    let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext" : "surveys";
    let fd = new FormData(); 
    fd.append('file', file[0]);
    fd.append('userId', userId);
    fd.append('assignmentId', assignmentId);
    fd.append('fileName', file[0].name);
    fd.append('campaignId', campaignId);
    fd.append('content-type',file[0].type); 

    const requestOptions = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? 
    { method: 'POST', headers: { 'Accept' : '*/*' }, body: fd } :
    { method: 'POST', headers: { 'Authorization': `Bearer ${accessToken}`, 'Accept' : '*/*' }, body: fd };

     return await fetch(`${URL_SURVEY_API}/${pathParam}/cm/response`, requestOptions);
}

const postEMResponse = async function (accessToken, file, userId, assignmentId, campaignId) {
    let fd = new FormData(); 
    fd.append('file', file[0]);
    fd.append('userId', userId);
    fd.append('assignmentId', assignmentId);
    fd.append('fileName', file[0].name);
    fd.append('campaignId', campaignId);
    fd.append('content-type',file[0].type); 
    
    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Accept' : '*/*',
        },
        body: fd
    }

     return await fetch(`${URL_SURVEY_API}/surveys/em/response`, requestOptions);
}

const postCampaign = function (accessToken, campaign, attachmentFiles) {
    let fd = new FormData();
    const objFileNames = []
    if(attachmentFiles){
        attachmentFiles.forEach((att) => {
            fd.append(`attachmentFile_queId_${att.queId}`, att.file)
            objFileNames.push({ queId: att.queId, fileName: att.file.name });
        });
    }
    fd.append('fileNames', JSON.stringify(objFileNames));
    fd.append('campaign', JSON.stringify(campaign));
    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Accept' : '*/*',
        },
        body: fd
    }
    return fetch(`${REACT_APP_URL_SURVEY_API_EXT}/surveys/campaign`, requestOptions).catch(error => { 
        console.log('Error creating campaign...');
        console.log(error);
        return {errorMessage: error} 
    });
}

function handleSaveTpsAnswers(authState,tpsContext,campaign,tpsResponseSelected, surveyCode) {
        let parts = [];
        if(surveyCode === TPS){
            parts = tpsContext.parts && tpsContext.parts.length > 0? tpsContext.parts.map(part=> {
                return {id:part.id?part.id:part}
            }): [];
        }else{
            parts = tpsContext.parts && tpsContext.parts.length > 0 ? tpsContext.parts : [];
        }
        const answers = tpsContext.answers && tpsContext.answers.length > 0?tpsContext.answers.map(ans=>{
            return {questionId: ans.questionId, answer: ans.answer}
        }):[];
        const request = {
            ...tpsContext,
            suppliers : [...tpsContext.suppliers], 
            answers : answers,
            parts: [...parts],
            campaignId: campaign.id,
            responseName: tpsContext.responseName?tpsContext.responseName:' '
        }
        if(tpsResponseSelected && tpsResponseSelected.id){
            if(surveyCode === TPS)
                request.tpsResponseId = tpsResponseSelected.id;
            else
                request.tpsMexResponseId = tpsResponseSelected.id;
        }
        return saveTpsAnswers( request,authState.accessToken.accessToken, surveyCode)
            .then(res => {
                return res;
            }).catch(error => {
                console.log(error);
        });
}

function handleSaveCooAnswers(authState,cooData,campaign,cooResponseSelected) {
    const parts = cooData.parts && cooData.parts.length > 0 ? cooData.parts : [];
    const answers = cooData.answers && cooData.answers.length > 0?cooData.answers.map(ans=>{
        return {questionId: ans.questionId, answer: ans.answer}
    }):[];
    const request = {
        ...cooData,
        suppliers : [...cooData.suppliers], 
        answers : answers,
        parts: [...parts],
        campaignId: campaign.id,
        responseName: cooData.responseName?cooData.responseName:' '
    }
    if(cooResponseSelected){
        request.cooResponseId = cooResponseSelected
    }
    return saveCooAnswers( request,authState.accessToken.accessToken)
        .then(res => {
            return res;
        }).catch(error => {
            console.log(error);
    });
}

const handleSaveOS = async (surveyResponse, surveyAnswers, campaign, userInfo, authState, ownershipData) => {
    let responseObj;
    if (surveyResponse && surveyResponse.id) {
        responseObj = surveyResponse;
        responseObj.updatedBy = userInfo.userID;
        responseObj.campaignId = campaign.id;
    } else {
        responseObj = getBaseResponseObject(campaign, userInfo);
        responseObj = { ...responseObj, ownershipContact: ownershipData && ownershipData.contacts ? ownershipData.contacts : [] }
    }
    let ansArray = surveyAnswers.map((item) => item.id);
    responseObj.surveyAnswers = responseObj.surveyAnswers.filter((ans) => { return ansArray.includes(ans.id) });
    if (surveyAnswers) {
        for (let currentAnswer of surveyAnswers) {
            let tmpAnswer = responseObj.surveyAnswers.find(ans => ans.questionId === currentAnswer.questionId);
            if (!tmpAnswer) {
                tmpAnswer = getBaseAnswer(userInfo);
                responseObj.surveyAnswers.push(tmpAnswer);
            }
            tmpAnswer.questionId = currentAnswer.questionId;
            tmpAnswer.answer = currentAnswer.answer;
        }
    }
    let itemsToDelete = ownershipData.contacts.filter((osc) => !isNaN(osc.id) && osc.deleted === true);
    if (!ownershipData.parentCheck) {
        responseObj.ownershipContact = [];
        itemsToDelete = ownershipData.contacts.filter(osc => !isNaN(osc.id));
    } else if (responseObj.ownershipContact.length > 0) {
        responseObj = { ...responseObj, ownershipContact: responseObj.ownershipContact.filter(osc => osc.deleted !== true) }
    }
    if (itemsToDelete.length > 0) {
        return await Promise.all([...itemsToDelete.map(item => deleteOSContact(item.id, authState.accessToken.accessToken)),
        saveUserResponse(responseObj, authState.accessToken.accessToken)]);
    } else {
        return Promise.all([saveUserResponse(responseObj, authState.accessToken.accessToken)]);
    }
};

export { saveUserAnswers, handleSaveOrUpdate, uploadSurveyFile, deleteAnswers, postCMSurvey, postEMSurvey, postCMResponse, postEMResponse, handleSaveTpsAnswers,handleSaveCooAnswers, handleSaveOS, postCampaign }


